import React from 'react';
import {useHistory} from 'react-router-dom';
// import {RoundButton} from 'components/Button';
import {StyledCaseHeader} from './styled';

import StyledIcon from 'components/acommon/StyledIcon';
import DatesAndGuests from '../../../../components/acommon/DatesAndGuestsBox';

export type CaseHeaderProps = {
  title: string;
};

function CaseHeader({title}: CaseHeaderProps) {
  const history = useHistory();
  return (
    <>
      <StyledCaseHeader>
        <div className="caseHeaderFirstMobileLine">
          <div className="mobileBackButton" onClick={history.goBack}>
            <StyledIcon name="backArrow" size="16px" />
          </div>
          <div className="caseHeaderTitle">{title}</div>
        </div>
        <div className="caseHeaderButtons">
          <DatesAndGuests />
          {/* <RoundButton icon="likeIcon" title="Like" />
        <RoundButton icon="locationIcon" title="Map" />
        <RoundButton icon="shareIcon" title="Share" /> */}
        </div>
      </StyledCaseHeader>
      {/* <DatesAndGuestsBox /> */}
    </>
  );
}

export default CaseHeader;
